export type MeetingStatusKey = 'Preparing' | 'Ready' | 'AwaitingReview' | 'Completed';

export const MeetingStatus: Record<MeetingStatusKey, Meetings.MeetingStatus> = {
  Preparing: 'preparing',
  Ready: 'ready',
  AwaitingReview: 'awaiting_review',
  Completed: 'completed',
};

export const MEETING_STATUS_LIST = [MeetingStatus.Preparing, MeetingStatus.Ready, MeetingStatus.AwaitingReview, MeetingStatus.Completed];
